export const creditCardConstants = {
	GET_CARDS: 'GET_CARDS',
	GET_ALL_CARDS: 'GET_ALL_CARDS'
}
